export const normalizeArtworkPoProvider = (value = "") =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim()
    .replace(/\s+/g, " ");

const OPTIONAL_ARTWORK_PO_PROVIDERS = new Set([
  "canworks",
  "digican",
  "digi can",
  "fast track",
  "fasttrack",
  "fastrack",
]);

export const artworkPoRequired = (manufacturerName = "") =>
  !OPTIONAL_ARTWORK_PO_PROVIDERS.has(
    normalizeArtworkPoProvider(manufacturerName)
  );
